import React, { useEffect, useState } from "react";
import { TagComponent } from "./TagComponent";
import colors from "common/styles/colors";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useTranslation } from "react-i18next";

interface ExpirationTimeTagProps {
  deliveryDate: string;
}

export const ExpirationTimeTag: React.FC<ExpirationTimeTagProps> = ({
  deliveryDate,
}) => {
  const [timeLeft, setTimeLeft] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const delivery = new Date(deliveryDate);
      const difference = delivery.getTime() - now.getTime();

      if (difference <= 0) {
        setTimeLeft(t("common.timeExpired"));
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    };

    calculateTimeLeft(); // Initial calculation

    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [deliveryDate, t]);

  return (
    <TagComponent
      color={timeLeft === t("common.timeExpired") ? colors.red : colors.premium}
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "5px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <AccessTimeIcon />
      <div
        style={{
          width: "100px",
        }}
      >
        {timeLeft}
      </div>
    </TagComponent>
  );
};
